<script setup>
import SettingsPage from '@/components/SettingsPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <SettingsPage />
  </Suspense>
  <ToastHost />
</template>
